/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_N7Inputs */

const en_to_xml_ref_n7 = /** @type {(inputs: To_Xml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A top level array is wrapped, because XML allows only one root element.`)
};

const ko_to_xml_ref_n7 = /** @type {(inputs: To_Xml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최상위 배열은 감싸입니다. XML이 루트 요소를 하나만 허용하기 때문입니다.`)
};

const ja_to_xml_ref_n7 = /** @type {(inputs: To_Xml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最上位の配列は包まれます。XML がルート要素を 1 つだけ許すからです。`)
};

/**
* | output |
* | --- |
* | "A top level array is wrapped, because XML allows only one root element." |
*
* @param {To_Xml_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_n7 = /** @type {((inputs?: To_Xml_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_n7(inputs)
	if (locale === "ko") return ko_to_xml_ref_n7(inputs)
	return ja_to_xml_ref_n7(inputs)
});